import { Button, ButtonProps } from "@mui/material";
import { FC } from "react";

interface SalifyDefaultButtonProps {
  text: string | undefined;
  buttonProps: ButtonProps;
}

const SalifyDefaultButton: FC<SalifyDefaultButtonProps> = ({ text, buttonProps }) => {
  return (
    <Button {...buttonProps} color={buttonProps?.color || "primary"} variant="contained">
      {text}
    </Button>
  );
};

SalifyDefaultButton.displayName = "SalifyDefaultButton";

export default SalifyDefaultButton;
